import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'

interface DarkModeState {
  isDarkMode: boolean
  isAutoDetect: boolean
}

const getInitialDarkMode = (): boolean => {
  const stored = localStorage.getItem('darkMode')
  if (stored !== null) {
    return JSON.parse(stored)
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

const initialState: DarkModeState = {
  isDarkMode: getInitialDarkMode(),
  isAutoDetect: localStorage.getItem('darkMode') === null,
}

const darkModeSlice = createSlice({
  name: 'darkMode',
  initialState,
  reducers: {
    toggleDarkMode: (state) => {
      state.isDarkMode = !state.isDarkMode
      state.isAutoDetect = false
      localStorage.setItem('darkMode', JSON.stringify(state.isDarkMode))
    },
    setDarkMode: (state, action: PayloadAction<boolean>) => {
      state.isDarkMode = action.payload
      state.isAutoDetect = false
      localStorage.setItem('darkMode', JSON.stringify(state.isDarkMode))
    },
    enableAutoDetect: (state) => {
      state.isAutoDetect = true
      localStorage.removeItem('darkMode')
      state.isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
    },
    updateSystemPreference: (state, action: PayloadAction<boolean>) => {
      if (state.isAutoDetect) {
        state.isDarkMode = action.payload
      }
    },
  },
})

export const { toggleDarkMode, setDarkMode, enableAutoDetect, updateSystemPreference } = darkModeSlice.actions

export const selectIsDarkMode = (state: RootState) => state.darkMode.isDarkMode
export const selectIsAutoDetect = (state: RootState) => state.darkMode.isAutoDetect

export default darkModeSlice.reducer
